"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userAddressDetailsController = function () {
  function userAddressDetailsController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userAddressDetailsController);
  }

  (0, _createClass3.default)(userAddressDetailsController, [{
    key: "formatDate",
    value: function formatDate(date) {
      if (!date) return false;

      return _common2.default.formatDate(date);
    }
  }]);
  return userAddressDetailsController;
}();

exports.default = userAddressDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-address-details/user-address-details.controller.js
 **/